'use strict';

var i18n = require('i18next');
var EditLteDns = require('actions/lteDns/EditLteDns');
var FormView = require('actions/wanDns/FormView');
var StaticView = require('actions/wanDns/StaticView');

/**
 * Action configuration for the LTE dns action component.
 */
module.exports = {
  title: i18n.t('actionWanDns.title'),
  Model: EditLteDns,
  FormView: FormView,
  TextView: StaticView,
};
